import { LENNAR_COM_ORIGIN } from 'src/constants/plans.constants'

/**
 * True when a value is a lennar.com page url that is safe to render as a link.
 * The url comes from the plan document (stamped by the change feed from the
 * lennar.com API), so it is external input reaching an href: anything that is
 * not an https url on lennar.com itself is refused rather than linked.
 */
export const isLennarComUrl = (value: unknown): value is string => {
  if (typeof value !== 'string') {
    return false
  }
  try {
    return new URL(value).origin === LENNAR_COM_ORIGIN
  } catch {
    return false
  }
}
